import axios from 'axios';
import { E_LocalStorageKey, LocalStorageUtil } from './LocalStorageUtil';
import { ApiResponse } from '../model/base';
import { toast } from 'sonner';
axios.interceptors.request.use((config) => {
  // 修改'Sec-Fetch-Dest'为'video'
  config.headers['Sec-Fetch-Dest'] = 'empty';

  // 修改'Sec-Fetch-Mode'为'cors'
  config.headers['Sec-Fetch-Mode'] = 'cors';

  // 修改'Sec-Fetch-Site'为'cross-site'
  config.headers['Sec-Fetch-Site'] = 'cross-site';
  return config;
});
export async function post(url: string, data: Record<string, any>) {
  const res = await axios({
    method: 'POST',
    url,
    baseURL:
      import.meta.env.VITE_ENV === 'prod'
        ? `https://eagle-api.solveclip.ai`
        : `https://eagle-api-test.solveclip.ai`,
    data,
    withCredentials: true,
    allowAbsoluteUrls: false,
  });
  return res;
}

export async function get(url: string, data: Record<string, any>) {
  const res = await axios({
    method: 'GET',
    url,
    baseURL:
      import.meta.env.VITE_ENV === 'prod'
        ? `https://eagle-api.solveclip.ai`
        : `https://eagle-api-test.solveclip.ai`,
    data,
    withCredentials: true,
    allowAbsoluteUrls: false,
  });
  return res;
}
export async function postData(url: string, data = {}, firstVisit?: boolean) {
  const token = LocalStorageUtil.getLocalStorage(
    E_LocalStorageKey.userDeviceId,
  );
  const URL =
    import.meta.env.VITE_ENV === 'prod'
      ? `https://eagle-api.solveclip.ai${url}`
      : `https://eagle-api-test.solveclip.ai${url}`;
  // Default options are marked with *
  const response = await fetch(URL, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'omit', // include, *same-origin, omit
    headers:
      token && !firstVisit
        ? {
            'Content-Type': 'application/json',
            Authorization: `bearer ${token}`,
            // 'Content-Type': 'application/x-www-form-urlencoded',
          }
        : {
            'Content-Type': 'application/json',
            // Authorization: `bearer ${token}`,
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  const resJson = await response.json();
  return processApiResponse(resJson);
}

export async function getData(url: string, data = {}) {
  let queryStr = '?';
  for (let k in data) {
    queryStr = queryStr + `${k}=${data[k]}&`;
  }
  queryStr = queryStr.slice(0, -1);
  const token = LocalStorageUtil.getLocalStorage(
    E_LocalStorageKey.userDeviceId,
  );
  const URL =
    import.meta.env.VITE_ENV === 'prod'
      ? `https://eagle-api.solveclip.ai${url}${queryStr}`
      : `https://eagle-api-test.solveclip.ai${url}${queryStr}`;
  // Default options are marked with *
  const response = await fetch(URL, {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'omit', // include, *same-origin, omit
    headers: token
      ? {
          'Content-Type': 'application/json',
          Authorization: `bearer ${token}`,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        }
      : {
          'Content-Type': 'application/json',
          // Authorization: `bearer ${token}`,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    // body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  const resJson = await response.json();
  return processApiResponse(resJson);
}

export async function processApiResponse(res: ApiResponse<any>) {
  // console.log(res)
  if (res.code === 0) {
    return res.data;
  } else if (res.code === 1000002) {
    // 重新登录
    LocalStorageUtil.removeLocalStorage(E_LocalStorageKey.userDeviceId);
    // toast.error(res.msg || 'please login')
    location.reload();
    throw new Error(res.msg);
  } else {
    throw new Error(res.msg);
  }
}
